import { createSlice } from '@reduxjs/toolkit';

const initialLangState = {
    en: {
        Header: {
            Settings: 'Settings',
            Logout: 'Logout',
        },
        Settings: {
            Settings: 'Settings',
            Account: 'Account',
            Security: 'Security',
            PlanAndBilling: 'Plan & Billing',
            Notifications: 'Notifications',
            TeamAndGroups: 'Team & Groups',
            Mailboxes: 'Mailboxes',
            Drive: 'Drive',
        },
        TeamAndGroups: {
            Team: 'Team',
            AddTeamMember: 'Add team member',
            EnterEmail: 'Enter email',
            Admin: 'Admin',
            Active: 'Active',
            Waiting: 'Waiting',
            Rejected: 'Rejected',
            Groups: 'Groups',
            AddGroup: 'Add group',
            EnterGroupName: 'Enter group name',
            SelectUsers: 'Select users',
        },
        Settings_Mailboxes: {
            Mailboxes: 'Mailboxes',
            AddMailbox: 'Add mailbox',
            EnterEmail: 'Enter email',
            SelectUsersOrGroups: 'Select users or groups',
        },


        Mailbox: {
            Mailbox: 'Mailbox',
            Inbox: 'Inbox',
            Sent: 'Sent',
            Spam: 'Spam',
            Trash: 'Trash',
            Archive: 'Archive',
            Starred: 'Starred',
            Important: 'Important',
        },

        // MyProfile: 'My Profile',

        // Lists Module
        Lists: 'Lists',
        AddList: 'Add List',
        CreatedBy: 'Created by',
        // CreateListModal_AddList: 'Add List',
        // CreateListModal_Templates: 'Templates',
        // CreateListModal_BlankList: 'Blank List',
        // CreateListModal_ExistList: 'Exist List',
        // CreateListModal_Excel: 'Excel',
        // CreateListModal_CSV: 'CSV',
        // CreateListModal_XML: 'XML',
        // CreateListModal_API: 'API',
        CreateBlankListModal_AddBlankList: 'Add Blank List',
        CreateBlankListModal_Name: 'Name',
        CreateBlankListModal_Name_Placeholder: 'Enter the name of the table',
        CreateBlankListModal_Name_RequiredMsg: 'Table name is required',
        CreateBlankListModal_Icon: 'Icon',
        CreateBlankListModal_Color: 'Color',
        CreateBlankListModal_Save: 'Save',
        CreateBlankListModal_Cancel: 'Cancel',

        // // List
        List_AddNewItem: 'Add new item',
        // List_DeleteList: 'Delete list',
        List_WorkflowAutomations: 'Workflow Automations',
        List_ExportData: 'Export Data',
        List_ImportData: 'Import Data',
        List_Delete: 'Delete',
        List_AreYouSureYouWantToDeleteTheseItems: 'Are you sure you want to delete these items ?',
        List_YesDelete: 'Yes, delete',
        List_Cancel: 'Cancel',
        List_Close: 'Close',
        List_AreYouSure: 'Are you sure ?',

        API_FIELDS_MSG: 'List name for api (should be unique value)',
        API_FIELDS_ERR_MSG: '* Should be a-z A-Z - _ and (unique)',
        API_FIELDS_COLUMN_MSG: 'Column name for api (should be unique value)',

        List_Filters: 'Filters',
        List_Sorting: 'Sorting',
        List_SortingColumn: 'Column',
        List_SortingColumnErr: 'Column is required, please select one',
        List_SortingSortingType: 'Sorting Type',
        List_SortingSortingTypeErr: 'Sorting type is required, please select one',
        List_SortingSave: 'Save',
        List_SortingCancel: 'Cancel',


        // List_AddView: 'Add view',
        // List_AddColumn: 'Add column',
        AddColumnModal_CreateColumn: 'Create a column',
        AddColumnModal_Next: 'Next',
        AddColumnModal_Cancel: 'Cancel',
        AddColumnModal_TextTitle: 'Text',
        AddColumnModal_TextSubTitle: 'Set a single line of text',
        AddColumnModal_LongTextTitle: 'Multiple lines of text',
        AddColumnModal_LongTextSubTitle: 'Use multiple lines of text',
        AddColumnModal_PhoneTitle: 'Phone',
        AddColumnModal_PhoneSubTitle: 'Phone number',
        AddColumnModal_EmailTitle: 'Email',
        AddColumnModal_EmailSubTitle: 'Email address',
        AddColumnModal_ListTitle: 'Choice',
        AddColumnModal_ListSubTitle: 'Offer a set of choices',
        AddColumnModal_DateTimeTitle: 'Date and time',
        AddColumnModal_DateTimeSubTitle: 'Set a date or date and time',
        AddColumnModal_NumberTitle: 'Number',
        AddColumnModal_NumberSubTitle: 'Set numeric values',
        AddColumnModal_YesNoTitle: 'Yes / No',
        AddColumnModal_YesNoSubTitle: 'Set a choice between two values, like yes/no',
        AddColumnModal_LinkTitle: 'Hyperlink',
        AddColumnModal_LinkSubTitle: 'Set a link to a web page, image, or other resources',
        AddColumnModal_ImageTitle: 'Image',
        AddColumnModal_ImageSubTitle: 'Set an image for an item',
        AddColumnModal_FileTitle: 'File',
        AddColumnModal_FileSubTitle: 'Set a file for an item',
        AddColumnModal_BelongsToTitle: 'Users / Groups',
        AddColumnModal_BelongsToSubTitle: 'Use users or groups from your organization',
        AddColumnModal_BelongsToListTitle: 'Belongs to list',
        AddColumnModal_BelongsToListSubTitle: 'Make a column from one list become the choices in another list column',
        AddNewColumnModal_CreateColumn: 'Create a column',
        AddNewColumnModal_Name: 'Name',
        AddNewColumnModal_NameFieldRequired: 'Name Field is required',
        AddNewColumnModal_Description: 'Description',
        AddNewColumnModal_NumberSymbol: 'Number Symbol',
        AddNewColumnModal_NumberOfDecimalPlaces: 'Number of decimal places',
        AddNewColumnModal_Custom: 'Custom',
        AddNewColumnModal_Automatic: 'Automatic',
        AddNewColumnModal_DefaultValue: 'Default Value',
        AddNewColumnModal_EnterADefaultValue: 'Enter a default value',
        AddNewColumnModal_MinimumValue: 'Minimum allowed value',
        AddNewColumnModal_EnterAMinimumValue: 'Enter a minimum value',
        AddNewColumnModal_MaximumValue: 'Maximum allowed value',
        AddNewColumnModal_EnterAMaximumValue: 'Enter a maximum value',
        AddNewColumnModal_IncludeTime: 'Include Time',
        AddNewColumnModal_Yes: 'Yes',
        AddNewColumnModal_No: 'No',
        AddNewColumnModal_None: 'None',
        AddNewColumnModal_TodaysDate: "Today's Date",
        AddNewColumnModal_SelectADate: 'Select a date',
        AddNewColumnModal_Choices: 'Choices',
        AddNewColumnModal_Choice: 'Choice',
        AddNewColumnModal_AddChoice: 'Add Choice',
        AddNewColumnModal_MaximumNumberOfCharacters: 'Maximum number of characters',
        AddNewColumnModal_AllowMultipleSelections: 'Allow multiple selections',
        AddNewColumnModal_Display: 'Display',
        AddNewColumnModal_Link: 'Link',
        AddNewColumnModal_Icon: 'Icon',
        AddNewColumnModal_AllowSelectionOfGroups: 'Allow selection of groups',
        AddNewColumnModal_ShowProfilePictures: 'Show profile pictures',
        AddNewColumnModal_RequireThatThisColumnContainsInformation: 'Require that this column contains information',
        AddNewColumnModal_Save: 'Save',
        AddRowModal_AddNewItem: 'Add new item',
        AddRowModal_EditItem: 'Edit item',
        AddRowModal_Save: 'Save',
        AddRowModal_Cancel: 'Cancel',
        Table_Th_Edit: 'Edit',
        Table_Th_HideThisColumn: 'Hide this column',
        Table_Th_MoveRight: 'Move right',
        Table_Th_MoveLeft: 'Move left',
        Table_Th_WidenColumn: 'Widen column',
        Table_Th_NarrowColumn: 'Narrow column',
        Table_Th_DeleteColumn: 'Delete column',
        AddViewModal_CreateView: 'Create view',
        AddViewModal_Save: 'Save',
        AddViewModal_Cancel: 'Cancel',
        AddViewModal_Name: 'View name',
        AddViewModal_Name_Placeholder: 'Enter the name of the view',
        AddViewModal_Name_RequiredMsg: 'View name is required',
        AddViewModal_ShowAs: 'Show as',
        AddViewModal_Month: 'Month',
        AddViewModal_Week: 'Week',
        AddViewModal_Day: 'Day',
        AddViewModal_OrganizeBoardBy: 'Organize board by',
        AddViewModal_CalendarDefaultLayout: 'Default layout',
        AddViewModal_List: 'List',
        AddViewModal_Gallery: 'Gallery',
        AddViewModal_Calendar: 'Calendar',
        AddViewModal_Board: 'Board',
        // ListViewMenuOptions_SaveView: 'Save view',
        // ListViewMenuOptions_SaveViewAs: 'Save view as',
        // ListViewMenuOptions_AddViewToSidebar: 'Add view to menu',
        // ListViewMenuOptions_SetCurrentViewAsDefault: 'Set current view as default',
        // ListViewMenuOptions_RenameView: 'Rename view',
        // ListViewMenuOptions_DeleteView: 'Delete view',
        // ListViewMenuOptions_FormatCurrentView: 'Format current view',
        // ListViewMenuOptions_AddOrRemoveFields: 'Add or remove fields',
        SaveViewAlert_SaveViewTitle: 'Are you sure ?',
        SaveViewAlert_Text: 'Save view',
        SaveViewAlert_Yes: 'Save',
        SaveViewAlert_Cancel: 'Cancel',
        SaveViewAsAlert_SaveViewAsTitle: 'Save view as',
        SaveViewAsAlert_InputPlaceholder: 'View name',
        RenameViewAlert_Title: 'Rename view',
        RenameViewAlert_InputPlaceholder: 'View name',
        // ViewShortcutAlert_Title: 'Are you sure ?',
        // ViewShortcutAlert_Text: 'Add view shortcut to menu',
        // ViewShortcutAlert_Yes: 'Yes',
        // ViewShortcutAlert__Cancel: 'Cancel',

        // // FilesManager Module
        // FilesManager_FilesManager: 'Files Manager',

        // SideMenu_MenuSettings: 'Menu Settings',
        // SideMenu_AddLink: 'Add Link',
        // SideMenu_Save: 'Save',

        // SideMenu_Icon: 'Icon',
        // SideMenu_Title: 'Title',
        // SideMenu_Link: 'Link',
        // SideMenu_OpenWith: 'Open with',
        // SideMenu_Delete: 'Delete',

        List_AddNewWorkflow: 'New Workflow',
        List_CreateWorkflow: 'Create Workflow',
    },
    he: {
        Header: {
            Settings: 'הגדרות',
            Logout: 'התנתק',
        },
        Settings: {
            Settings: 'הגדרות',
            Account: 'חשבון',
            Security: 'אבטחה',
            PlanAndBilling: 'תוכנית וחיוב',
            Notifications: 'התראות',
            TeamAndGroups: 'צוות וקבוצות',
            Mailboxes: 'תיבות דואר',
            Drive: 'אחסון',
        },
        TeamAndGroups: {
            Team: 'צוות',
            AddTeamMember: 'הוסף משתמש',
            EnterEmail: 'הזן כתובת דוא"ל',
            Admin: 'מנהל',
            Active: 'פעיל',
            Waiting: 'בהמתנה',
            Rejected: 'נדחה',
            Groups: 'קבוצות',
            AddGroup: 'הוסף קבוצה',
            EnterGroupName: 'הזן שם כבוצה',
            SelectUsers: 'בחר משתמשים',
        },
        Settings_Mailboxes: {
            Mailboxes: 'Mailboxes',
            AddMailbox: 'Add mailbox',
            EnterEmail: 'Enter email',
            SelectUsersOrGroups: 'Select users or groups',
        },
        Mailbox: {
            Mailbox: 'תיבת דואר',
            Inbox: 'דואר נכנס',
            Sent: 'דואר נשלח',
            Spam: 'ספאם',
            Trash: 'אשפה',
            Archive: 'ארכיון',
            Starred: 'מסומן בכוכב',
            Important: 'חשוב',
        },

        // MyProfile: 'פרופיל שלי',
        Lists: 'רשימות',
        AddList: 'הוספת רשימה',
        CreatedBy: 'נוצר ע״י',
        // CreateListModal_AddList: 'הוספת רשימה',
        // CreateListModal_Templates: 'תבניות',
        // CreateListModal_BlankList: 'רשימה ריקה',
        // CreateListModal_ExistList: 'רשימה קיימת',
        // CreateListModal_Excel: 'Excel',
        // CreateListModal_CSV: 'CSV',
        // CreateListModal_XML: 'XML',
        // CreateListModal_API: 'API',
        CreateBlankListModal_AddBlankList: 'הוספת רשימה ריקה',
        CreateBlankListModal_Name: 'שם',
        CreateBlankListModal_Name_Placeholder: 'הוסף שם רשימה כאן',
        CreateBlankListModal_Name_RequiredMsg: 'שם רשימה שדה חובה',
        CreateBlankListModal_Icon: 'סמל',
        CreateBlankListModal_Color: 'צבע',
        CreateBlankListModal_Save: 'שמור',
        CreateBlankListModal_Cancel: 'ביטול',
        List_AddNewItem: 'הוספת פריט חדש',
        // List_DeleteList: 'מחק רשימה',
        List_WorkflowAutomations: 'אוטומציות של תהליכי עבודה',
        List_ExportData: 'ייצוא נתונים',
        List_ImportData: 'ייבוא נתונים',
        List_Delete: 'מחק',
        List_AreYouSureYouWantToDeleteTheseItems: 'האם אתה בטוח שברצונך למחוק פריטים אלה ?',
        List_YesDelete: 'כן, מחק',
        List_Cancel: 'בטל',
        List_Close: 'לסגור',
        List_AreYouSure: 'האם אתה בטוח ?',

        API_FIELDS_MSG: 'שם רשימה עבור API (צריך להיות ערך ייחודי)',
        API_FIELDS_ERR_MSG: '* צריך להיות a-z A-Z - _ ו-(ייחודי)',
        API_FIELDS_COLUMN_MSG: 'שם עמודה עבור API (צריך להיות ערך ייחודי)',

        List_Filters: 'מסננים',
        List_Sorting: 'מיון',
        List_SortingColumn: 'עמודה',
        List_SortingColumnErr: 'עמודה נדרשת, אנא בחר אחת',
        List_SortingSortingType: 'סוג מיון',
        List_SortingSortingTypeErr: 'נדרש סוג מיון, אנא בחר אחד מהם',
        List_SortingSave: 'שמור',
        List_SortingCancel: 'ביטול',

        // List_AddView: 'הוספת תצוגה',
        // List_AddColumn: 'הוסף עמודה',
        AddColumnModal_CreateColumn: 'צור עמודה',
        AddColumnModal_Next: 'הבא',
        AddColumnModal_Cancel: 'ביטול',
        AddColumnModal_TextTitle: 'טקסט',
        AddColumnModal_TextSubTitle: 'הגדר שורת טקסט בודדת',
        AddColumnModal_LongTextTitle: 'שורות טקסט מרובות',
        AddColumnModal_LongTextSubTitle: 'השתמש בשורות טקסט מרובות או בעיצוב עשיר',
        AddColumnModal_PhoneTitle: 'טלפון',
        AddColumnModal_PhoneSubTitle: 'מספר טלפון',
        AddColumnModal_EmailTitle: 'דוא"ל',
        AddColumnModal_EmailSubTitle: 'כתובת דוא"ל',
        AddColumnModal_ListTitle: 'בחירה',
        AddColumnModal_ListSubTitle: 'הצע קבוצה של אפשרויות בחירה',
        AddColumnModal_DateTimeTitle: 'תאריך ושעה',
        AddColumnModal_DateTimeSubTitle: 'הגדרת תאריך או תאריך ושעה',
        AddColumnModal_NumberTitle: 'מספר',
        AddColumnModal_NumberSubTitle: 'הגדר ערכים מספריים',
        AddColumnModal_YesNoTitle: 'כן / לא',
        AddColumnModal_YesNoSubTitle: 'הגדר בחירה בין שני ערכים, כגון כן / לא',
        AddColumnModal_LinkTitle: 'היפר-קישור',
        AddColumnModal_LinkSubTitle: 'הגדר קישור חדש לדף אינטרנט, תמונה או למשאב אחר.',
        AddColumnModal_ImageTitle: 'תמונה',
        AddColumnModal_ImageSubTitle: 'הגדר תמונה עבור פריט',
        AddColumnModal_FileTitle: 'קובץ',
        AddColumnModal_FileSubTitle: 'הגדר קובץ עבור פריט',
        AddColumnModal_BelongsToTitle: 'אדם / קבוצה',
        AddColumnModal_BelongsToSubTitle: 'השתמש בשמות של אנשים או קבוצות מהארגון שלך',
        AddColumnModal_BelongsToListTitle: 'שייך ל רשימה',
        AddColumnModal_BelongsToListSubTitle: 'הפיכת עמודה מרשימה אחת לבחירות בעמודה אחרת של רשימה',
        AddNewColumnModal_CreateColumn: 'צור עמודה',
        AddNewColumnModal_Name: 'שם',
        AddNewColumnModal_NameFieldRequired: 'שם עמודה שדה חובה',
        AddNewColumnModal_Description: 'תיאור',
        AddNewColumnModal_NumberSymbol: 'סמל מספר',
        AddNewColumnModal_NumberOfDecimalPlaces: 'מספר המקומות העשרוניים',
        AddNewColumnModal_Custom: 'מותאם אישית',
        AddNewColumnModal_Automatic: 'אוטומטי',
        AddNewColumnModal_DefaultValue: 'ערך ברירת מחדל',
        AddNewColumnModal_EnterADefaultValue: 'הזן ערך ברירת מחדל',
        AddNewColumnModal_MinimumValue: 'הערך המינימלי המותר',
        AddNewColumnModal_EnterAMinimumValue: 'הזן ערך מינימלי',
        AddNewColumnModal_MaximumValue: 'הערך המקסימלי המותר',
        AddNewColumnModal_EnterAMaximumValue: 'הזן ערך מקסימלי',
        AddNewColumnModal_IncludeTime: 'כלול שעה',
        AddNewColumnModal_Yes: 'כן',
        AddNewColumnModal_No: 'לא',
        AddNewColumnModal_None: 'ללא',
        AddNewColumnModal_TodaysDate: 'התאריך של היום',
        AddNewColumnModal_SelectADate: 'בחר תאריך',
        AddNewColumnModal_Choices: 'בחירות',
        AddNewColumnModal_Choice: 'בחירה',
        AddNewColumnModal_AddChoice: 'הוסף בחירה',
        AddNewColumnModal_MaximumNumberOfCharacters: 'מספר תווים מקסימלי',
        AddNewColumnModal_AllowMultipleSelections: 'אפשר בחירות מרובות',
        AddNewColumnModal_Display: 'להציג',
        AddNewColumnModal_Link: 'קישור',
        AddNewColumnModal_Icon: 'סמל',
        AddNewColumnModal_AllowSelectionOfGroups: 'אפשר בחירה של קבוצות',
        AddNewColumnModal_ShowProfilePictures: 'הצג תמונות פרופיל',
        AddNewColumnModal_RequireThatThisColumnContainsInformation: 'דרוש שעמודה זו תכיל מידע',
        AddNewColumnModal_Save: 'שמור',
        AddRowModal_AddNewItem: 'הוספת פריט חדש',
        AddRowModal_EditItem: 'עריכת פריט',
        AddRowModal_Save: 'שמור',
        AddRowModal_Cancel: 'ביטול',
        Table_Th_Edit: 'ערוך',
        Table_Th_HideThisColumn: 'הסתר עמודה זו',
        Table_Th_MoveRight: 'הזז ימינה',
        Table_Th_MoveLeft: 'הזז שמאלה',
        Table_Th_WidenColumn: 'הרחב עמודה',
        Table_Th_NarrowColumn: 'צמצם עמודה',
        Table_Th_DeleteColumn: 'מחק עמודה',
        AddViewModal_CreateView: 'צור תצוגה',
        AddViewModal_Save: 'שמור',
        AddViewModal_Cancel: 'ביטול',
        AddViewModal_Name: 'שם תצוגה',
        AddViewModal_Name_Placeholder: 'הוסף שם תצוגה כאן',
        AddViewModal_Name_RequiredMsg: 'שם תצוגה שדה חובה',
        AddViewModal_ShowAs: 'הצג כ',
        AddViewModal_Month: 'חודש',
        AddViewModal_Week: 'שבוע',
        AddViewModal_Day: 'יום',
        AddViewModal_OrganizeBoardBy: 'ארגן את הלוח לפי',
        AddViewModal_CalendarDefaultLayout: 'פריסה ברירת מחדל',
        AddViewModal_List: 'רשימה',
        AddViewModal_Gallery: 'גלריה',
        AddViewModal_Calendar: 'יומן',
        AddViewModal_Board: 'לוח',
        // ListViewMenuOptions_SaveView: 'שמירת תצוגה',
        // ListViewMenuOptions_SaveViewAs: 'שמירת תצוגה בשם',
        // ListViewMenuOptions_AddViewToSidebar: 'הוסף תצוגה לתפריט',
        // ListViewMenuOptions_SetCurrentViewAsDefault: 'הגדרת התצוגה הנוכחית כברירת מחדל',
        // ListViewMenuOptions_RenameView: 'שינוי שם התצוגה',
        // ListViewMenuOptions_DeleteView: 'מחק תצוגה',
        // ListViewMenuOptions_FormatCurrentView: 'עיצוב התצוגה הנוכחית',
        // ListViewMenuOptions_AddOrRemoveFields: 'הוספה או הסרה של שדות',
        SaveViewAlert_SaveViewTitle: 'אתה בטוח ?',
        SaveViewAlert_Text: 'שמור תצוגה',
        SaveViewAlert_Yes: 'שמור',
        SaveViewAlert_Cancel: 'ביטול',
        SaveViewAsAlert_SaveViewAsTitle: 'שמור תצוגה בשם',
        SaveViewAsAlert_InputPlaceholder: 'שם תצוגה',
        RenameViewAlert_Title: 'שינוי שם התצוגה',
        RenameViewAlert_InputPlaceholder: 'שם התצוגה',
        // ViewShortcutAlert_Title: 'אתה בטוח ?',
        // ViewShortcutAlert_Text: 'הוסף קיצור דרך לתצוגה לתפריט',
        // ViewShortcutAlert_Yes: 'כן',
        // ViewShortcutAlert__Cancel: 'ביטול',
        // FilesManager_FilesManager: 'מנהל הקבצים',
        // SideMenu_MenuSettings: 'הגדרות תפריט',
        // SideMenu_AddLink: 'הוסף קישור',
        // SideMenu_Save: 'שמור',
        // SideMenu_Icon: 'איקון',
        // SideMenu_Title: 'כותרת',
        // SideMenu_Link: 'קישור',
        // SideMenu_OpenWith: 'פתח ב',
        // SideMenu_Delete: 'מחיקה',
        List_AddNewWorkflow: 'הוספת Workflow',
        List_CreateWorkflow: 'צור Workflow',
    },
    ar: {
        Header: {
            Settings: 'إعدادات',
            Logout: 'الخروج',
        },
        Settings: {
            Settings: 'إعدادات',
            Account: 'حساب',
            Security: 'حماية',
            PlanAndBilling: 'الخطة والفواتير',
            Notifications: 'إشعارات',
            Team: 'فريق',
            TeamAndGroups: 'الفريق والمجموعات',
            Mailboxes: 'صناديق البريد',
            Drive: 'تخزين',
        },
        TeamAndGroups: {
            Team: 'فريق',
            AddTeamMember: 'إضافة عضو',
            EnterEmail: 'أدخل البريد الإلكتروني',
            Admin: 'مسؤل',
            Active: 'نشط',
            Waiting: 'انتظار',
            Rejected: 'مرفوض',
            Groups: 'المجموعات',
            AddGroup: 'إضافة مجموعة',
            EnterGroupName: 'أدخل اسم المجموعة',
            SelectUsers: 'تحديد المستخدمين',
        },
        Settings_Mailboxes: {
            Mailboxes: 'Mailboxes',
            AddMailbox: 'Add mailbox',
            EnterEmail: 'Enter email',
            SelectUsersOrGroups: 'Select users or groups',
        },
        Mailbox: {
            Mailbox: 'صندوق البريد',
            Inbox: 'صندوق الوارد',
            Sent: 'مرسل',
            Spam: 'رسائل مزعجة',
            Trash: 'نفاية',
            Archive: 'أرشيف',
            Starred: 'مميز',
            Important: 'مهم',
        },

        // MyProfile: 'الملف الشخصي',
        Lists: 'القوائم',
        AddList: 'اضافة قائمة',
        CreatedBy: 'المنشئ',
        // CreateListModal_AddList: 'اضافة قائمة',
        // CreateListModal_Templates: 'قوالب جاهزة',
        // CreateListModal_BlankList: 'قائمة فارغة',
        // CreateListModal_ExistList: 'قائمة موجودة',
        // CreateListModal_Excel: 'Excel',
        // CreateListModal_CSV: 'CSV',
        // CreateListModal_XML: 'XML',
        // CreateListModal_API: 'API',
        CreateBlankListModal_AddBlankList: 'إضافة قائمة فارغة',
        CreateBlankListModal_Name: 'اسم',
        CreateBlankListModal_Name_Placeholder: 'أدخل اسم القائمة هنا',
        CreateBlankListModal_Name_RequiredMsg: 'اسم القائمة حقل اجباري',
        CreateBlankListModal_Icon: 'رمز',
        CreateBlankListModal_Color: 'اللون',
        CreateBlankListModal_Save: 'حفظ',
        CreateBlankListModal_Cancel: 'الغاء',
        List_AddNewItem: 'إضافة عنصر جديد',
        // List_DeleteList: 'حذف القائمة',
        List_WorkflowAutomations: 'אוטומציות של תהליכי עבודה',
        List_ExportData: 'ייצוא נתונים',
        List_ImportData: 'ייבוא נתונים',
        List_Delete: 'حذف',
        List_AreYouSureYouWantToDeleteTheseItems: 'هل أنت متأكد أنك تريد حذف هذه العناصر ؟',
        List_YesDelete: 'نعم، حذف',
        List_Cancel: 'الغاء',
        List_Close: 'اغلاق',
        List_AreYouSure: 'هل أنت متأكد ؟',

        API_FIELDS_MSG: 'שם רשימה עבור API (צריך להיות ערך ייחודי)',
        API_FIELDS_ERR_MSG: '* צריך להיות a-z A-Z - _ ו-(ייחודי)',
        API_FIELDS_COLUMN_MSG: 'שם עמודה עבור API (צריך להיות ערך ייחודי)',

        List_Filters: 'מסננים',
        List_Sorting: 'מיון',
        List_SortingColumn: 'עמודה',
        List_SortingColumnErr: 'עמודה נדרשת, אנא בחר אחת',
        List_SortingSortingType: 'סוג מיון',
        List_SortingSortingTypeErr: 'נדרש סוג מיון, אנא בחר אחד מהם',
        List_SortingSave: 'שמור',
        List_SortingCancel: 'ביטול',

        // List_AddView: 'إضافة عرض',
        // List_AddColumn: 'إضافة عمود',
        AddColumnModal_CreateColumn: 'إنشاء عمود',
        AddColumnModal_Next: 'التالي',
        AddColumnModal_Cancel: 'الغاء',
        AddColumnModal_TextTitle: 'نص',
        AddColumnModal_TextSubTitle: 'تعيين سطر واحد من النص',
        AddColumnModal_LongTextTitle: 'أسطر متعددة من النص',
        AddColumnModal_LongTextSubTitle: 'استخدم أسطر متعددة من النص',
        AddColumnModal_PhoneTitle: 'هاتف',
        AddColumnModal_PhoneSubTitle: 'رقم الهاتف',
        AddColumnModal_EmailTitle: 'البريد الإلكتروني',
        AddColumnModal_EmailSubTitle: 'عنوان البريد الإلكتروني',
        AddColumnModal_ListTitle: 'خيار',
        AddColumnModal_ListSubTitle: 'عرض مجموعة من الخيارات',
        AddColumnModal_DateTimeTitle: 'التاريخ والوقت',
        AddColumnModal_DateTimeSubTitle: 'تعيين تاريخ أو تاريخ ووقت',
        AddColumnModal_NumberTitle: 'رقم',
        AddColumnModal_NumberSubTitle: 'تعيين القيم الرقمية',
        AddColumnModal_YesNoTitle: 'نعم / لا',
        AddColumnModal_YesNoSubTitle: 'حدد خيارًا بين قيمتين، مثل نعم/لا',
        AddColumnModal_LinkTitle: 'رابط تشعبي',
        AddColumnModal_LinkSubTitle: 'تعيين رابط لصفحة ويب أو صورة أو موارد أخرى',
        AddColumnModal_ImageTitle: 'صورة',
        AddColumnModal_ImageSubTitle: 'تعيين صورة لعنصر',
        AddColumnModal_FileTitle: 'ملف',
        AddColumnModal_FileSubTitle: 'تعيين ملف لعنصر',
        AddColumnModal_BelongsToTitle: 'المستخدمون / المجموعات',
        AddColumnModal_BelongsToSubTitle: 'اختيار المستخدمين أو المجموعات من مؤسستك',
        AddColumnModal_BelongsToListTitle: 'ينتمي إلى قائمة',
        AddColumnModal_BelongsToListSubTitle: 'جعل عمود من قائمة واحدة يصبح الخيارات في عمود قائمة أخرى',
        AddNewColumnModal_CreateColumn: 'إنشاء عمود',
        AddNewColumnModal_Name: 'الاسم',
        AddNewColumnModal_NameFieldRequired: 'حقل الاسم مطلوب',
        AddNewColumnModal_Description: 'وصف',
        AddNewColumnModal_NumberSymbol: 'رمز الرقم',
        AddNewColumnModal_NumberOfDecimalPlaces: 'عدد الأماكن العشرية',
        AddNewColumnModal_Custom: 'مخصص',
        AddNewColumnModal_Automatic: 'تلقائي',
        AddNewColumnModal_DefaultValue: 'القيمة الافتراضية',
        AddNewColumnModal_EnterADefaultValue: 'أدخل قيمة افتراضية',
        AddNewColumnModal_MinimumValue: 'الحد الأدنى للقيمة المسموح بها',
        AddNewColumnModal_EnterAMinimumValue: 'أدخل الحد الأدنى للقيمة',
        AddNewColumnModal_MaximumValue: 'الحد الأقصى للقيمة المسموح بها',
        AddNewColumnModal_EnterAMaximumValue: 'أدخل القيمة القصوى',
        AddNewColumnModal_IncludeTime: 'تشمل الوقت',
        AddNewColumnModal_Yes: 'نعم',
        AddNewColumnModal_No: 'لا',
        AddNewColumnModal_None: 'لا شيء',
        AddNewColumnModal_TodaysDate: "تاريخ اليوم",
        AddNewColumnModal_SelectADate: 'حدد تاريخًا',
        AddNewColumnModal_Choices: 'الخيارات',
        AddNewColumnModal_Choice: 'خيار',
        AddNewColumnModal_AddChoice: 'إضافة خيار',
        AddNewColumnModal_MaximumNumberOfCharacters: 'الحد الأقصى لعدد الأحرف',
        AddNewColumnModal_AllowMultipleSelections: 'السماح باختيارات متعددة',
        AddNewColumnModal_Display: 'عرض',
        AddNewColumnModal_Link: 'رابط',
        AddNewColumnModal_Icon: 'رمز',
        AddNewColumnModal_AllowSelectionOfGroups: 'السماح باختيار المجموعات',
        AddNewColumnModal_ShowProfilePictures: 'إظهار صور الملف الشخصي',
        AddNewColumnModal_RequireThatThisColumnContainsInformation: 'يجب أن يحتوي هذا العمود على معلومات',
        AddNewColumnModal_Save: 'حفظ',
        AddRowModal_AddNewItem: 'إضافة عنصر جديد',
        AddRowModal_EditItem: 'تعديل العنصر',
        AddRowModal_Save: 'حفظ',
        AddRowModal_Cancel: 'الغاء',
        Table_Th_Edit: 'تعديل',
        Table_Th_HideThisColumn: 'إخفاء هذا العمود',
        Table_Th_MoveRight: 'تحريك لليمين',
        Table_Th_MoveLeft: 'تحريك لليسار',
        Table_Th_WidenColumn: 'توسيع العمود',
        Table_Th_NarrowColumn: 'تضييق العمود',
        Table_Th_DeleteColumn: 'حذف العمود',
        AddViewModal_CreateView: 'إنشاء عرض',
        AddViewModal_Save: 'حفظ',
        AddViewModal_Cancel: 'الغاء',
        AddViewModal_Name: 'اسم العرض',
        AddViewModal_Name_Placeholder: 'أضف اسم العرض هنا',
        AddViewModal_Name_RequiredMsg: 'اسم العرض حقل مطلوب',
        AddViewModal_ShowAs: 'إظهار كـ',
        AddViewModal_Month: 'شهر',
        AddViewModal_Week: 'اسبوع',
        AddViewModal_Day: 'يوم',
        AddViewModal_OrganizeBoardBy: 'تنظيم اللوحة حسب',
        AddViewModal_CalendarDefaultLayout: 'التخطيط الافتراضي',
        AddViewModal_List: 'قائمة',
        AddViewModal_Gallery: 'معرض',
        AddViewModal_Calendar: 'تقويم',
        AddViewModal_Board: 'لوحة',
        // ListViewMenuOptions_SaveView: 'حفظ العرض',
        // ListViewMenuOptions_SaveViewAs: 'حفظ العرض باسم',
        // ListViewMenuOptions_AddViewToSidebar: 'إضافة عرض إلى القائمة',
        // ListViewMenuOptions_SetCurrentViewAsDefault: 'تعيين العرض الحالي كعرض افتراضي',
        // ListViewMenuOptions_RenameView: 'إعادة تسمية العرض',
        // ListViewMenuOptions_DeleteView: 'حذف العرض',
        // ListViewMenuOptions_FormatCurrentView: 'تنسيق العرض الحالي',
        // ListViewMenuOptions_AddOrRemoveFields: 'إضافة أو إزالة الحقول',
        SaveViewAlert_SaveViewTitle: 'هل أنت متأكد ؟',
        SaveViewAlert_Text: 'حفظ العرض',
        SaveViewAlert_Yes: 'حفظ',
        SaveViewAlert_Cancel: 'الغاء',
        SaveViewAsAlert_SaveViewAsTitle: 'حفظ العرض باسم',
        SaveViewAsAlert_InputPlaceholder: 'اسم العرض',
        RenameViewAlert_Title: 'إعادة تسمية العرض',
        RenameViewAlert_InputPlaceholder: 'اسم العرض',
        // ViewShortcutAlert_Title: 'هل أنت متأكد ؟',
        // ViewShortcutAlert_Text: 'إضافة اختصار العرض إلى القائمة',
        // ViewShortcutAlert_Yes: 'نعم',
        // ViewShortcutAlert__Cancel: 'الغاء',
        // FilesManager_FilesManager: 'إدارة الملفات',
        // SideMenu_MenuSettings: 'הגדרות תפריט',
        // SideMenu_AddLink: 'הוסף קישור',
        // SideMenu_Save: 'שמור',
        // SideMenu_Icon: 'איקון',
        // SideMenu_Title: 'כותרת',
        // SideMenu_Link: 'קישור',
        // SideMenu_OpenWith: 'פתח ב',
        // SideMenu_Delete: 'מחיקה',
        List_AddNewWorkflow: 'הוספת Workflow',
        List_CreateWorkflow: 'צור Workflow',
    },
}

const langSlice = createSlice({
    name: 'langConfiguration',
    initialState: initialLangState,
    reducers: {}
})

export const langActions = langSlice.actions;
export default langSlice;